// The tenant feature `statics-feedback` (#165 AK12), as the portal learns it — the
// same shape as src/core/ceremonyFeature.ts and cmsFeature.ts, one rule for
// every flag.
//
// The flag is server truth: with it off, every statics feedback root answers
// FEATURE_DISABLED. The portal has no flag query of its own, so it learns the
// answer from the first statics feedback call it makes — the shell's probe
// (MainLayout → probeStaticsFeedbackFeature, for every signed-in person: the team
// page, the officials' tool and the givers' own schedule all hang off it) or
// a statics feedback page itself — and hides every statics feedback surface once it knows the
// feature is off. Unknown counts as on: the entries are first-frame hints like
// every rail hint, and the pages say so in place if the server refuses.
import { reactive } from 'vue'
import type { Client } from '@urql/vue'
import { StaticsFeedbackFeatureProbeDocument } from './staticsFeedbackFeature.operations'
import { hasErrorCode } from 'src/modules/cms/cmsRender'

export const staticsFeedbackFeature = reactive({
  /** The server answered FEATURE_DISABLED. */
  off: false,
  /** The shell's probe ran (once per session). */
  probed: false,
})

/** Records what a statics feedback answer says about the flag. */
export function noteStaticsFeedbackAnswer(error: unknown): void {
  if (hasErrorCode(error, 'FEATURE_DISABLED')) staticsFeedbackFeature.off = true
  else if (!error) staticsFeedbackFeature.off = false
}

/** Asks once per session whether the statics feedback service answers. */
export async function probeStaticsFeedbackFeature(client: Client): Promise<void> {
  if (staticsFeedbackFeature.probed) return
  staticsFeedbackFeature.probed = true
  try {
    const r = await client.query(StaticsFeedbackFeatureProbeDocument, {}).toPromise()
    if (hasErrorCode(r.error, 'FEATURE_DISABLED')) staticsFeedbackFeature.off = true
  } catch {
    // Unreachable is not "off": the pages will say what is wrong.
  }
}

/** Test seam. */
export function resetStaticsFeedbackFeature(): void {
  staticsFeedbackFeature.off = false
  staticsFeedbackFeature.probed = false
}
